/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { listAllDeliveryMethodsByMerchantId } from '../fn/delivery-methods-admin/list-all-delivery-methods-by-merchant-id';
import { ListAllDeliveryMethodsByMerchantId$Params } from '../fn/delivery-methods-admin/list-all-delivery-methods-by-merchant-id';
import { PagedModelDeliveryMethodPageResponse } from '../models/paged-model-delivery-method-page-response';


/**
 * Admin endpoints for delivery method management. Requires EASYLOT_ADMIN role.
 */
@Injectable({ providedIn: 'root' })
export class DeliveryMethodsAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listAllDeliveryMethodsByMerchantId()` */
  static readonly ListAllDeliveryMethodsByMerchantIdPath = '/merchants/{merchantId}/delivery/methods';

  /**
   * Lists delivery methods for a merchant (admin).
   *
   * Returns a paginated list of all delivery methods configured for the specified merchant. Requires EASYLOT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllDeliveryMethodsByMerchantId()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllDeliveryMethodsByMerchantId$Response(params: ListAllDeliveryMethodsByMerchantId$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelDeliveryMethodPageResponse>> {
    const obs = listAllDeliveryMethodsByMerchantId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists delivery methods for a merchant (admin).
   *
   * Returns a paginated list of all delivery methods configured for the specified merchant. Requires EASYLOT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllDeliveryMethodsByMerchantId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllDeliveryMethodsByMerchantId(params: ListAllDeliveryMethodsByMerchantId$Params, context?: HttpContext): Observable<PagedModelDeliveryMethodPageResponse> {
    const resp = this.listAllDeliveryMethodsByMerchantId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelDeliveryMethodPageResponse>): PagedModelDeliveryMethodPageResponse => r.body)
    );
  }

}
